import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router';
import { QuizBuilder, type QuizBuilderData } from '@/components/quiz-builder/QuizBuilder';
import { useSaveQuizlet } from '@/queries/quizlets';
import { BackgroundWaves } from '@/components/BackgroundWaves';
import styles from './quiz-page.module.scss';

export const Route = createFileRoute('/quizlets/create')({
  component: CreateQuizlet,
  beforeLoad: ({ context }) => {
    const { user, authLoading } = context as { user: any; authLoading: boolean };
    if (authLoading) return;
    if (!user) {
      throw redirect({ to: '/' });
    }
  },
});

function CreateQuizlet() {
  const navigate = useNavigate();
  const saveQuizlet = useSaveQuizlet();

  const handleSave = async (data: QuizBuilderData) => {
    try {
      await saveQuizlet.mutateAsync({
        name: data.name,
        original_prompt: data.original_prompt,
        is_daily_knowledge: data.is_daily_knowledge,
        questions: data.questions,
      });
      // useSaveQuizlet automatically navigates to the new quizlet on success
    } catch (error) {
      console.error('Failed to save quizlet:', error);
      throw error;
    }
  };

  const handleCancel = () => {
    // Show confirmation if there are unsaved changes
    const confirmed = window.confirm(
      'Are you sure you want to discard your quiz?'
    );

    if (confirmed) {
      navigate({ to: '/quizlets' });
    }
  };

  return (
    <div className={styles.quizPage}>
      <BackgroundWaves />

      {/* Breadcrumb Navigation */}
      <div className={styles.quizPage__breadcrumb}>
        <nav className={styles.quizPage__nav}>
          <a
            href="/quizlets"
            className={styles.quizPage__link}
            onClick={(e) => {
              e.preventDefault();
              navigate({ to: '/quizlets' });
            }}
          >
            Quizlets
          </a>
          <span className={styles.quizPage__separator}>›</span>
          <span className={styles.quizPage__current}>Create Quiz</span>
        </nav>
      </div>

      <QuizBuilder onSave={handleSave} onCancel={handleCancel} />
    </div>
  );
}
